import { createContext, useContext, useState } from "react";

const OrderEntryModalContext = createContext(null);

export function OrderEntryModalProvider({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const value = { isModalOpen, setModalOpen: setIsModalOpen };
  return (
    <OrderEntryModalContext.Provider value={value}>
      {children}
    </OrderEntryModalContext.Provider>
  );
}

export function useOrderEntryModal() {
  return useContext(OrderEntryModalContext);
}
